import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  trackWrapper: {
    flex: 1,
    height: 3,
    borderRadius: 999,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)",
    overflow: "hidden",
    position: "relative",
  },
  fill: {
    height: "100%",
    borderRadius: 999,
    backgroundColor: "#00a884",
    transition: "width 0.25s ease",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      inset: 0,
      background: "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.35) 50%, transparent 100%)",
      animation: "$shimmer 1.4s infinite",
      backgroundSize: "200% 100%",
    },
  },
  "@keyframes shimmer": {
    "0%": { backgroundPosition: "-200% 0" },
    "100%": { backgroundPosition: "200% 0" },
  },
  label: {
    fontSize: 12,
    fontVariantNumeric: "tabular-nums",
    color: theme.palette.type === "dark" ? "#8696a0" : "#54656f",
    minWidth: 32,
    textAlign: "right",
    flexShrink: 0,
  },
}));

const ProgressBarCustom = ({ progress = 0 }) => {
  const classes = useStyles();
  const [displayed, setDisplayed] = useState(progress);

  useEffect(() => {
    setDisplayed(progress);
  }, [progress]);

  return (
    <div className={classes.root} role="progressbar" aria-valuenow={Math.round(displayed)} aria-valuemin={0} aria-valuemax={100}>
      <div className={classes.trackWrapper}>
        <div className={classes.fill} style={{ width: `${Math.min(100, Math.round(displayed))}%` }} />
      </div>
      <span className={classes.label}>{Math.round(displayed)}%</span>
    </div>
  );
};

export default ProgressBarCustom;